import Image from 'next/image'
import { useLocale, useTranslations } from 'next-intl'
import { parseLanguageFromLocale, parseRegionFromLocale } from '@/setup/locales'
import { cn } from '@/utils/styles/cn'
import { CustomDeeplinkProps } from '@/utils/url/deeplinks'

interface IPlayStoreDownloadButtonProps extends CustomDeeplinkProps {
    className?: string
    containerClassName?: string
    hideRating?: boolean
}

export const PlayStoreDownloadButton = ({
    className,
    containerClassName,
    customDeeplink,
    hideRating,
}: IPlayStoreDownloadButtonProps) => {
    const t = useTranslations()
    const locale = useLocale()

    const currentRegion = parseRegionFromLocale(locale).toLowerCase()
    const currentLanguage = parseLanguageFromLocale(locale)

    return (
        <div className={cn('flex flex-col items-center gap-y-2 w-fit', containerClassName)}>
            <a
                href={
                    customDeeplink ||
                    t('shared.playStoreDownloadUrl', {
                        region: currentRegion,
                        lang: currentLanguage,
                    })
                }
                target="_blank"
                hrefLang={locale}
                className="app-download-button"
                rel="noreferrer"
            >
                <Image
                    src="/_images/meta/download-on-the-play-store.png"
                    alt="Download on the Play Store"
                    width={215}
                    height={64}
                    style={{ aspectRatio: 47 / 14 }}
                    className={cn(className)}
                />
            </a>

            {!hideRating && (
                <div className="flex flew-row items-center">
                    <span className="font-semibold">⭐️ 4,5</span>
                    <span className="ml-1 font-normal text-black/80">(2280)</span>
                </div>
            )}
        </div>
    )
}
